import React, { useEffect } from 'react'
import Event from './eventImg/event-8-nov.webp'


const Event21 = () => {
    useEffect(() => {
        document.title = "IEC workshop on Corrosion Controls";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>8 November 2025</h1>
        <h3 className='text-center'>IEC workshop on Corrosion Controls</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='Distinguished Lecture on Field Measurements & Data Storage in HVAC'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/V9rnBWrWwPg=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event21




